<div class="banner" id="home">
  <div class="content-section">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-12 col-lg-7 leftSec">
          <div class="banner-content">
            <p class="banner-eyebrow">{{ 'banner.banner_eyebrow' | translate }}</p>
            <h1 class="banner-title">
              {{ 'banner.banner_title_line1' | translate }}<br />
              <span class="highlight">{{ 'banner.banner_title_highlight' | translate }}</span>
              {{ 'banner.banner_title_line2' | translate }}
            </h1>
            <p class="banner-desc">{{ 'banner.banner_desc' | translate }}</p>

            <div class="d-flex flex-wrap gap-3 banner-cta">
              <a class="btn btn-primary" routerLink="/{{ lang !== 'en' ? lang : '' }}" fragment="our-programs">
                {{ 'banner.banner_cta_primary' | translate }}
              </a>
              <a class="btn btn-outline-light" routerLink="/{{ lang !== 'en' ? lang : '' }}" fragment="get-in-touch">
                {{ 'banner.banner_cta_secondary' | translate }}
              </a>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-5 rightSec">
          <owl-carousel-o [options]="customOptions" class="banner-carousel">
            <ng-container *ngFor="let slide of slides">
              <ng-template carouselSlide [id]="slide.id">
                <div class="banner-image">
                  <img [src]="slide.src" [alt]="slide.alt" loading="eager" />
                </div>
              </ng-template>
            </ng-container>
          </owl-carousel-o>
        </div>
      </div>
    </div>
  </div>

  <img class="banner-wave" src="assets/images/svg-icons/hero-wave.svg" alt="" loading="lazy" />
</div>
